import { apiRequest } from "../../../services/api";
import { IRegister } from "../type/registerType";

export const createAccount = async (data: IRegister) => {
  const response = await apiRequest<IRegister>("POST", "/auth/register", {
    name: data.name,
    icNumber: data.icNumber,
    ...(data.address && { address: data.address }),
    phoneNumber: data.phoneNumber,
    email: data.email,
    password: data.password,
    role: data.role,
    ...(data.branchId && { branchId: data.branchId }),
  });
  return response.data;
};
